import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=5dcfd572&"
import script from "./ConversationMessage.vue?vue&type=script&lang=js&"
export * from "./ConversationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VChip,VIcon,VTextField,VTextarea})
